import ContainerBlockGenericType from "../ContainersBlocks/ContainerBlockGenericType";

function AVG
    ({ id, isConnectable, type, selected }) {
    return (
        <ContainerBlockGenericType
            id={id}
            isConnectable={isConnectable}
            type={type}
            selected={selected}
            flagNumber={42}
            userConfiguration={true}
            showLabelInput={true}
        />
    );
}
export default AVG
